import { VALIDATED_BEFORE_MARKER } from './constants.mjs';

export default function markAsValidatedBefore({ target }) {
  target.dataset[VALIDATED_BEFORE_MARKER] = '';
  target.classList.add('validated-before');
}
